import axiosInstance from "../axios/axios-configuration"
import { CancelToken } from "axios";
import { Protocol_Type } from "../shared/enums";
import { IField } from "../shared/interfaces";
import { ITag } from "@fluentui/react";

const controller = 'Fields';

const getFieldsByViewName = (aooId: number, viewName: string, cancelToken?: CancelToken): Promise<IField[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetFieldsByViewName`, { cancelToken: cancelToken, params: { viewName: viewName } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getAllFields = (aooId: number, uorId: number, cancelToken?: CancelToken): Promise<IField[]> => {
    return axiosInstance.get(`${controller}/${aooId}/${uorId}/GetAllFields`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getFieldsByType = (aooId: number, uorId: number, tipoProtocollo: Protocol_Type, cancelToken?: CancelToken): Promise<IField[]> => {
    return axiosInstance.get(`${controller}/${aooId}/${uorId}/GetFieldsByType/${tipoProtocollo}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getLookupSuggestion = (aooId: number, listId: string, fieldTitle: string, searchValue: string, cancelToken?: CancelToken): Promise<ITag[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetLookupSuggestion/${listId}/${fieldTitle}/${searchValue}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    getFieldsByViewName,
    getAllFields,
    getFieldsByType,
    getLookupSuggestion
}